import type { Side } from "@design-lab/shared";
import api from "common/utils/api";
import { notifyError } from "common/utils/app-monitoring/notify";
import { useArtwork } from "./useArtwork";
import { useArtworkForm } from "./useArtworkForm";

export function useClearManualEdits() {
  const { getMachineBySide } = useArtwork();
  const { form } = useArtworkForm();

  return async (side: Side) => {
    // Clear the form flag
    form.setValue(`info.${side}.editImageManual`, false, { shouldDirty: true });

    // Clear the artwork machine's manualEditUrl and related fields
    const machine = getMachineBySide(side);
    const ctx = machine.state.context as any;
    if (ctx?.artwork) {
      const updatedArtwork = {
        ...ctx.artwork,
        manualEditUrl: null,
        manualEditNoTrimUrl: null,
        editImageManual: false
      };
      machine.send({
        type: "reset",
        targetState: "finished",
        context: { ...ctx, artwork: updatedArtwork }
      });

      // Sync with backend to clear manual edit state
      if (ctx.artworkId) {
        try {
          const pathParams = { dtf_artwork_id: ctx.artworkId };
          const bodyParams = {
            manual_edit: false,
            remove_background: form.getValues(`info.${side}.removeBackground`) || false,
            start_new_edit: false,
            enhancement_tier: form.getValues(`info.${side}.enhancementTier`)
          };

          await api.dtf.completeRefineSession(pathParams, bodyParams as any);
        } catch (error) {
          notifyError(error as Error, {
            hook: "useClearManualEdits",
            step: "sync_reset_manual_edit_with_backend",
            params: {
              artwork_id: ctx.artworkId,
              side,
              manual_edit: false,
              remove_background: form.getValues(`info.${side}.removeBackground`) || false,
              start_new_edit: false,
              enhancement_tier: form.getValues(`info.${side}.enhancementTier`)
            }
          });
        }
      }
    }
  };
}
